/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../services.ts"/>
/// <reference path="./customer_interfaces.ts"/>

namespace DealerwareWebServices {
    "use strict";

    import IDealerwareCustomer = DealerwareWebServices.IDealerwareCustomer

    export class Customer implements IDealerwareCustomer {
        public static $inject: string[] = ['$injector'];

        private $q: any;
        private $timeout: any;
        private $rootScope: any;
        private _customerId: number;
        private _locationId: number;
        private DealerwareCustomerModel: any;
        private DealerwareDriversLicenseModel: any;
        private DealerwareCreditCardCollection: any;
        private DealerwareCreditCardModel: any;
        private NotesCollection: IDealerwareNotesCollection;
        private $DealerwareNotesFactory: any;
        private DealerwareLocationFactory: any;
        private _contractCollection: any;

        public accountSettings: any;
        public driversLicense: any;
        public creditCard: any;
        public creditCards: any;
        public contracts: any;
        public paymentProcessor: any;

        constructor(public $injector : any) {
            this.$q = this.$injector.get('$q');
            this.$timeout = this.$injector.get('$timeout');
            this.$rootScope = this.$injector.get('$rootScope');
            this.DealerwareCustomerModel = this.$injector.get('DealerwareCustomerModel');
            this.DealerwareDriversLicenseModel = this.$injector.get('DealerwareDriversLicenseModel');
            this.DealerwareCreditCardCollection = this.$injector.get('DealerwareCreditCardCollection');
            this.DealerwareCreditCardModel = this.$injector.get('DealerwareCreditCardModel');
            this.$DealerwareNotesFactory = this.$injector.get('$DealerwareNotesFactory');
            this.DealerwareLocationFactory = this.$injector.get('LocationFactory');
        }

        get noteCollection() : IDealerwareNotesCollection {
            if (!this.NotesCollection && this.locationId && this.customerId) {
                this.NotesCollection = this.$DealerwareNotesFactory.getCustomerInstance(this.locationId, this.customerId);
            }
            return this.NotesCollection;
        }

        get contractCollection() : any {
            if (!this._contractCollection) {
                this._contractCollection = this.$injector.get('DealerwareContractCollection');
            }
            return this._contractCollection;
        }

        get locationId() : number {
            return this._locationId;
        }

        set locationId(id: number) {
            this._locationId = id;
        }

        get customerId() : number {
            return this._customerId;
        }

        set customerId(id : number)  {
            if (id && this._customerId && id != this._customerId) {
                throw "Customer ID Mismatch";
            }
            this._customerId = id;
        }

        get fullName() : string {
            return (
                        this.accountSettings &&
                        this.accountSettings.hasOwnProperty('data') &&
                        angular.isObject(this.accountSettings.data) &&
                        this.accountSettings.data.hasOwnProperty('full_name')) ?
                        this.accountSettings.data.full_name : undefined;
        }

        set fullName(fullName : string) {}

        get email() : string {
            return  (
                this.accountSettings &&
                this.accountSettings.hasOwnProperty('data') &&
                angular.isObject(this.accountSettings.data) &&
                this.accountSettings.data.hasOwnProperty('email')
            ) ? this.accountSettings.data.email : undefined;
        }

        public clear() : void {
            this._customerId    =   null;
            this.clearAccountSettings();
        }

        public clearAccountSettings() : void {
            this.accountSettings = undefined;
        }

        public loadAccountSettings(locationId?: number, customerId?: number) : ng.IPromise<{}> {
            var _deferred   =   this.$q.defer();
            var _self       =   this;

            if (locationId) { this.locationId = locationId; }
            if (customerId) { this.customerId = customerId; }

            if (!this.locationId) {
                _deferred.reject({response : {data: {'message': 'Location Id is undefined'}}});
            } else if (!this.customerId) {
                _deferred.reject({response : {data: {'message': 'Customer Id is undefined'}}});
            } else {
                this.DealerwareCustomerModel.get({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        id: this.customerId,
                        include_insurance_preferences: true
                    }
                }).then(
                    function(returnValue : any, response : any) {
                        _self.accountSettings = returnValue;
                        _deferred.resolve({returnValue: returnValue,response : response});
                    },
                    function(response : any) {
                        _deferred.reject(response);
                    }
                );

            }

            return _deferred.promise;
        }

        public loadDriversLicense() : ng.IPromise<{}> {
            var _deferred   =   this.$q.defer();
            var _self       =   this;

            if (!this.locationId) {
                _deferred.reject({response : {data: {'message': 'Location Id is undefined'}}});
            } else if (!this.customerId) {
                _deferred.reject({response : {data: {'message': 'Customer Id is undefined'}}});
            } else {
                this.DealerwareDriversLicenseModel.get({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        customer_id: this.customerId
                    }
                }).then(
                    function(returnValue : any,response : any){
                        _self.driversLicense = returnValue;
                        _deferred.resolve({returnValue: returnValue,response : response});
                    },
                    function(response : any) {
                        if (response.status === 404) {
                            _self.driversLicense = new _self.DealerwareDriversLicenseModel({ country: 'US' });
                            _deferred.resolve({ returnValue: _self.driversLicense, response: response });
                        } else {
                            _deferred.reject(response);
                        }
                    }
                );
            }

            return _deferred.promise;
        }

        public deleteInsuranceImage(locationId?: number, customerId?: number) : ng.IPromise<{}> {
            var _deferred = this.$q.defer();
            var _self = this;

            if (locationId) { this.locationId = locationId; }
            if (customerId) { this.customerId = customerId; }

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location Id is undefined' }}});
            } else if (!this.customerId) {
                _deferred.reject({ response: { data: { message: 'Customer Id is undefined' }}});
            } else {
                this.DealerwareCustomerModel.deleteInsuranceImage({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        id: this.customerId
                    }
                }).finally(function() { _deferred.resolve(); });
            }

            return _deferred.promise;
        }

        public saveInsurance() : ng.IPromise<{}> {
            var _deferred = this.$q.defer(),
                _self = this;

            this.accountSettings.$saveInsurance({
                promise: true,
                params: {
                    location_id: this.locationId,
                    id: this.customerId
                }
            }).then(
                function(returnValue: any) { _deferred.resolve({ returnValue: returnValue }); },
                function(response: any) { _deferred.reject(response); }
            );

            return _deferred.promise;
        }

        public loadCreditCards() : ng.IPromise<{}> {
            var _deferred = this.$q.defer();

            if (!this.locationId) {
                _deferred.reject({ response: { data: { message: 'Location ID is undefined' }}});
            } else if (!this.customerId) {
                _deferred.reject({ response: { data: { message: 'Customer ID is undefined' }}});
            } else {
                this.DealerwareCreditCardCollection.index({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                        customer_id: this.customerId,
                        sort_by: 'created_at',
                        sort_direction: 'desc'
                    }
                }).then(
                    (creditCards: any, response: any) => {
                        var activeIdx = creditCards.data.findIndex((cc: any) => cc.data.default === true);

                        this.creditCards = creditCards;
                        this.creditCard = creditCards.data[activeIdx];
                        _deferred.resolve({ returnValue: creditCards, response: response });
                    },
                    (response: any) => {
                        _deferred.reject(response);
                    }
                );
            }

            return _deferred.promise;
        }

        public loadPaymentProcessor() : ng.IPromise<{}> {
            var _deferred   =   this.$q.defer();
            var _self       =   this;

            if (!this.locationId) {
                _deferred.reject({response : {data: {'message': 'Location Id is undefined'}}});
            } else {
                this.DealerwareCreditCardModel.paymentProcessor({
                    promise: true,
                    params: {
                        location_id: this.locationId,
                    }
                }).then(
                    function(returnValue : any,response : any){
                        _self.paymentProcessor = returnValue.data.provider.toLowerCase();
                        _deferred.resolve({returnValue: returnValue,response : response});
                    },
                    function(response : any) {
                        if (response.status === 404) {
                            _deferred.resolve({ returnValue: _self.paymentProcessor, response: response });
                        } else {
                            _deferred.reject(response);
                        }
                    }
                );
            }
            return _deferred.promise;
        }

        loadContracts(customerId?: number) : ng.IPromise<{}> {
            var _self = this,
                _deferred = this.$q.defer();

            if (customerId) { this.customerId = customerId; }

            if (!this.customerId) {
                _deferred.reject({ response: { data: { message: 'Customer ID is undefined' }}});
            } else {
                this.contractCollection.customerContracts({
                    params: {
                        location_id: this.locationId,
                        id: this.customerId,
                        sort_by: 'pickup',
                        sort_direction: 'desc'
                    },
                    promise: true
                }).then(
                    function(returnValue: any, response: any) {
                        _self.contracts = returnValue;
                        _deferred.resolve({ returnValue: returnValue, response: response });
                    },
                    function(response: any) {
                        _deferred.reject(response);
                    }
                );
            }

            return _deferred.promise;
        }

        public loadNotes() : ng.IPromise<{}> {
            var _self = this;
            var _deferred = this.$q.defer();
            this.noteCollection.loadNotes().then(
                function(response) { _deferred.resolve(response); },
                function(response) { _deferred.reject(response); }
            );

            return _deferred.promise;
        }

        public searchDisplay() : string {
            return this.accountSettings.searchDisplay();
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareCustomer", Customer);


    export class CustomerFactory implements IDealerwareCustomerFactory {
        public static $inject: string[] = ['$q','$injector'];

        constructor(public $q : any,public $injector : any) {}

        public loadCustomer(locationId: number, id: number) : ng.IPromise<{}> {
            var _deferred = this.$q.defer();
            var _customer = new Customer(this.$injector);

            _customer.loadAccountSettings(locationId, id).then(
                function(response : ng.IHttpPromiseCallbackArg<{}>) {
                    _deferred.resolve({customer: _customer});
                },
                function(returnValue: any) {
                    _deferred.reject({customer: _customer,response : returnValue.response});
                }
            );
            return _deferred.promise;
        }

        public getInstance(): IDealerwareCustomer {
            return new Customer(this.$injector);
        }

        public convertToInstance(customerData: any) : IDealerwareCustomer {
            var _new: any;

            if (customerData && (customerData instanceof Customer)) {
                _new = customerData;
            } else if (customerData) {
                _new = new Customer(this.$injector);
                _new.accountSettings = customerData;
            } else {
                _new = customerData;
            }

            return _new;
        }
    }

    getDealerwareWebServicesModule().service("$dealerwareCustomerFactory", CustomerFactory);
}
